import { all, call, select, takeLatest } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { putError, putSuccess } from "../helpers";
import { CLI, NEWSLETTERLOCAL, NEWSLETTERSERVER, PROGRAM } from "../../constants/state";
import getOptionalCinemaId from "../../functions/cinemaAndTimeRangeFilters/getOptionalCinemaId";
import checkItemByCinemaId from "../../functions/cinemaAndTimeRangeFilters/checkItemByCinemaId";

const getData = state => ({
    newsletterData: state.getIn([NEWSLETTERLOCAL]).toJS(),
    campaignsData: state.getIn([NEWSLETTERSERVER, 'campaigns', 'data']).toJS(),
    weeks: state.getIn([NEWSLETTERSERVER, 'weeks']).toJS(),
    currentWeek: state.getIn([NEWSLETTERSERVER, 'currentWeek']),
    multicinemaMode: state.getIn([CLI, 'multiCinemaMode'],),
    currentClientCinemaId: state.getIn([CLI, 'cinemaClientId'])
})

const getItem = (state, keyArray) => state.getIn(keyArray)

const  itemKeyArrays = {
    movies: [PROGRAM, 'cliMovies', 'items'],
    movie_performances: [PROGRAM, 'cliMovies', 'items'],
    content: [PROGRAM, 'ads', 'items'],
    highlights: [PROGRAM, 'highlights', 'items'],
    text: [NEWSLETTERLOCAL, 'texts', 'items'],
    image: [NEWSLETTERLOCAL, 'images', 'items']
}


function* filterItem(campaignId, sectionId, optionalCinemaId, itemId, itemType, filteredData) {
    const item = yield select(getItem, [...itemKeyArrays[itemType], itemId])
    let isInCinema = yield false

    
    if(item) {
        if(false === optionalCinemaId || 'text' === itemType || 'image' === itemType) {
            isInCinema = yield true
        } else {
            const itemJS = yield item.toJS()
            const cinemasAttr = yield ('movies' === itemType || 'movie_performances' === itemType) ? 'cinemaIds' : 'cinemasFilter'
            isInCinema = yield checkItemByCinemaId(itemJS, optionalCinemaId, cinemasAttr)
        }
    }
    
    if(item && isInCinema) {
        if(!filteredData.items[campaignId].items.hasOwnProperty(sectionId)) {
            filteredData.items[campaignId].items[sectionId] = yield [itemId]
        } else {
            yield filteredData.items[campaignId].items[sectionId].push(itemId)
        }
    }
}


function* filterSection(campaignId, sectionId, optionalCinemaId, content, structure, filteredData) {
    if(!content || 0 === content.length)  {
        return
    }

    yield all(content.map(itemId => call(
        filterItem,
        campaignId,
        sectionId,
        optionalCinemaId,
        itemId,
        structure.itemType,
        filteredData
    )))
}

function* checkCurrentWeek(campaignId, content, weeks, currentWeek, filteredData) {
    if(content && content.hasOwnProperty('currentWeek') && weeks.includes(parseInt(content.currentWeek))) {
        filteredData.items[campaignId].currentWeek = yield parseInt(content.currentWeek)
    } else {
        filteredData.items[campaignId].currentWeek = yield parseInt(currentWeek)
    }
}

function* filterNewsletter(campaignId, content, cinemaId, structure, multicinemaMode, currentClientCinemaId, weeks, currentWeek, filteredData) {
    if(!filteredData.items.hasOwnProperty(campaignId)) {
        filteredData.items[campaignId]  = yield {
            items: {}
        }
    }
    const newsletterCinemaId = yield cinemaId ? cinemaId : false
    const optionalCinemaId = yield getOptionalCinemaId(multicinemaMode, newsletterCinemaId, currentClientCinemaId)
    yield call(
        checkCurrentWeek, 
        campaignId,
        content,
        weeks,
        currentWeek,
        filteredData
    )
    if(!content)  {
        return
    }

    yield all(structure.order.map(sectionId => call(
        filterSection,
        campaignId,
        sectionId,
        optionalCinemaId,
        content.items[sectionId],
        structure.items[sectionId],
        filteredData
    )))
}

export function* newsletterFilterData() {
    const data = yield select(getData)
    const weeks = yield data.weeks.map(w => w.isoWeek)

    const filteredData = yield {
        items: {}
    }
    
    yield all(data.campaignsData.order.map(id => call(
        filterNewsletter, 
        id, 
        data.newsletterData.newsletters.items[id], 
        data.campaignsData.items[id].cinema,
        data.campaignsData.items[id].structure,
        data.multicinemaMode,
        data.currentClientCinemaId,
        weeks,
        data.currentWeek,
        filteredData
    )))

    return yield filteredData
}


export function* filterData() {
    try {
        const filteredData = yield call(newsletterFilterData)

        yield putSuccess(actionTypes.NEWSLETTER_FILTER_SUCCESS, filteredData)
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.NEWSLETTER_FILTER_ERROR, e.message)
    }
}


function* watchNewsletterFilterRequest() {
    yield takeLatest(actionTypes.NEWSLETTER_FILTER_REQUEST, filterData);
}

export default watchNewsletterFilterRequest